import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import axios from "axios";

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
 Vue.prototype.api = "https://www.kmppartners.info:1122";
// Vue.prototype.api = "http://localhost:1110";
//  Vue.prototype.api = "http://192.168.10.128:1110";
 
new Vue({
  router,
  store,
  vuetify,
  
  render: h => h(App)
}).$mount('#app')
